module.exports = __webpack_public_path__ + "static/NeueMontreal-Bold-2c04b9cc863981609b052bf2e7ff51c7.woff2";